import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { GoogleSheetsIntegrationResponse } from '../models/responses/google-sheets-integration-response';
import { environment } from '../environments/environments';
import { CreateGoogleSheetIntegrationRequest } from '../models/requests/create-google-sheet-integration-request';

@Injectable({
  providedIn: 'root'
})
export class GoogleSheetIntegrationService {

  constructor(private httpClient: HttpClient) { }

  create(request: CreateGoogleSheetIntegrationRequest) {
    return this.httpClient.post<GoogleSheetsIntegrationResponse>(`${environment.googleSheetsIntegrationUrl}`, request);
  }

  delete(id: number) {
    const options = { params: new HttpParams().set('id', id) }
    return this.httpClient.delete<GoogleSheetsIntegrationResponse>(`${environment.googleSheetsIntegrationUrl}`, options)
  }
}
